<template>
    <v-tooltip open-delay="750" bottom>
        <template #activator="{ on }">
            <v-chip
                x-small
                class="px-1 cp"
                v-on="on"
                :color="color"
                label>
                <span class="text--primary">{{ label }}</span>
            </v-chip>
        </template>
        <span class="tooltip-content">{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
    export default {
        props: {
        color: String,
        label: String,
        tooltip: String,
        },
    };
</script>
